import React from "react";
import { SystemLogo } from "./SystemLogo";
import { MobileLogo } from "./MobileLogo";
import { Route, Switch } from 'react-router-dom';
import { StickyContainer } from 'react-sticky';
import { Sat } from "../Sat/Sat";
import { RouteTopbar } from "./RouteTopbar";
import { Breakpoint } from './../../components/Breakpoint/Breakpoint';
import { Footer } from "../../components/Footer/Footer";
import { Marketing } from "../Marketing/Marketing";
import { About } from "../About/About";
import { Dev } from "../Dev/Dev";
import { Helmet } from 'react-helmet';

import logo from "../../assets/system3-logo.svg"
import "./home.scss";

const description = "Soluciones de marketing y servicios digitales para particulares y empresas. Producción y emisión de video, desarrollo de programas de gestión a medida y webs corporativas, servicios de asistencia técnica, reparación y mantenimiento"
export default class extends React.Component
{
	render()
	{
		return (
			<React.Fragment>
				<Helmet>
					<title>System 3 - 30 Años de servicios digitales</title>
					<meta name="og:title" content={"30 Años de servicios digitales"} />
					<meta name="description" content={description} />
					<meta name="og:description" content={description} />
					<meta name="og:site_name" content={"System 3"} />
					<meta property="og:type" content={"website"} />
					<meta property="og:url" content={"https://system3.es"} />
					<meta property="og:image" content={logo} />
				</Helmet>
				<Breakpoint server large up>
					<SystemLogo />
				</Breakpoint>
				<Breakpoint medium down >
					<MobileLogo />
				</Breakpoint>
				<StickyContainer className="content">
					<RouteTopbar />
					{/* <Route component={Sat} />	
					<Route component={Marketing} />
					<Route component={Dev} />
					<Route component={About} /> */}
					<Marketing />
					<Dev />
					<Sat />
					<About />
				</StickyContainer>
				{/* <div></div> */}
				<Footer copyrightHolder="System3" unsplash="4227372/system3-web" />
			</React.Fragment>
		);
	}
}